import { useDispatch } from "react-redux"
import { FaNewspaper, FaPlus } from "react-icons/fa";
import { setActiveComponent } from "../../Reducer/RevenueModuleSlice";

function MainMenuRevenue(){
    
    const dispatch = useDispatch()

    const handleClickComponent = (value) => {
        dispatch(setActiveComponent(value))
    }

    return(
            <div className="ModalGlobalDiv">
                <div className="ChoiceSystemMainDiv">
                    <div className="ChoiceSystemColumnDiv">
                        <button className="ChoiceSystemMainButton Options" onClick={() => {handleClickComponent('enteringDataMenu')}}>
                            <div className="IconButtonMainMenuDiv"> <FaPlus/> </div> Внесение данных
                        </button>
    
                        <button className="ChoiceSystemMainButton Options" onClick={() => {handleClickComponent('reports')}}>
                            <div className="IconButtonMainMenuDiv"> <FaNewspaper/> </div> Отчеты
                        </button>
                    </div>
                </div>
            </div>
        )
}

export default MainMenuRevenue